import React, { FC, ReactNode } from 'react';

import { ExternalUp24, Plus24 } from '../../icons';
import { Button2, Button2Props } from '../Button2';
import { Typography } from '../Typography';


type IconType = 'arrow' | 'plus';

interface TileButtonProps extends Omit<Button2Props, 'variant' | 'variantType' | 'size'> {
    text: ReactNode;
    iconType?: IconType;
}

const iconMap: Record<IconType, React.ReactNode> = {
    arrow: <ExternalUp24 sx={({ spacing }) => ({ fontSize: spacing(6) })} />,
    plus: <Plus24 sx={({ spacing }) => ({ fontSize: spacing(6) })} />,
};

export const TileButton: FC<TileButtonProps> = ({
    text,
    iconType = 'arrow',
    sx,
    ...props
}) => (
    <Button2
        variant='secondary'
        variantType='main'
        sx={[{
            flexDirection: 'column',
            gap: 2,
            py: 6,
            px: 8,
            borderRadius: 6,
            color: 'grayscale.shade95',
            '&:disabled': {
                color: 'grayscale.shade60',
                bgcolor: 'grayscale.shade0',
            },
            '&:hover': {
                backgroundColor: 'grayscale.shade20',
            },
            '&:active': {
                backgroundColor: 'grayscale.shade40',
            },
        },
        ...Array.isArray(sx) ? sx : [sx]]}
        {...props}
    >
        {iconMap[iconType]}

        <Typography
            variant='mediumBody2'
            noWrap
        >
            {text}
        </Typography>
    </Button2>
);
